<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="train-menu">
    <div id="trainBriefLeftMenu" class="panel-left {{(showHeader) ? '' : 'train-menu-no-border'}}" [style.top]='panelLeftPosY' [style.left]='panelLeftPosX' [style.width]='leftWidth' [style.height]='leftHeight'>
        <a href="javascript:void(0)" *ngIf="showHeader" class="menu-item-link" (click)='showTrainTabData("Data", "Train");'>
            Data
        </a>
        <a href="javascript:void(0)" *ngIf="showHeader" class="menu-item-link" (click)='showTrainTabData("History", "Train");'>
      History
    </a>
        <a href="javascript:void(0)" *ngIf="showHeader" class="menu-item-link" (click)='showTrainTabData("Notes", "Train");'>
      Notes
    </a>
        <a href="javascript:void(0)" *ngIf="showHeader" class="menu-item-link" (click)='showTrainTabData("Profile", "Train");'>
      Profile
    </a>
        <a href="javascript:void(0)" *ngIf="showHeader && (user && user.isUserManagerOrDirector && cancelPlanEnable)" class="menu-item-link" (click)='cancelAllPlannedLocomotive();'>
            Cancel All Planned Locomotives
    </a>
        <a href="javascript:void(0)" *ngIf="showHeader && ((user && !user.isUserManagerOrDirector) || !cancelPlanEnable)" class="menu-item-link disabled">
            Cancel All Planned Locomotives
    </a>
    </div>
    <div class="panel-right" id="contextPanelID" [style.top]='panelRightPosY' [style.left]='panelRightPosX'>
        <div class="train-textPanel">
            <span class="train-id">{{train && train.trainIdentifier ? train.trainIdentifier : '-'}}</span>
        </div>
        <div class="train-infoPanel">
            <ul>
                <li>
                    <span class="train-label">
            {{trainLabel?.trainName}}
					</span>
                    <span class="train-value">
						{{train && train.trainName ? train.trainName : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.lastReported}}
					</span>
                    <span class="train-value">
						{{train.lastReported ? train.lastReported : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.lastReported}} {{trainLabel.reportedLocation}}
					</span>
                    <span class="train-value">
						{{train && train.lastReportingCityState ? train.lastReportingCityState : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.origin}}
					</span>
                    <span class="train-value">
						{{train && train.originTerminal ? train.originTerminal : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.destination}}
					</span>
                    <span class="train-value">
						{{train && train.destinationTerminal ? train.destinationTerminal : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.performance}}
					</span>
                    <span class="train-value" *ngIf='train && returnDash([train.performanceCity, train.performanceState, train.performanceTime, train.performanceIndicator])'>
						-
					</span>
                    <span class="train-value" *ngIf='train && !returnDash([train.performanceCity, train.performanceState, train.performanceTime, train.performanceIndicator])'>
						{{train.trainType? train.trainType + " " : ""}} {{train.performanceCity}} {{train.performanceCity ? ', ': ''}} {{train.performanceState}} {{train.performanceTime}} {{train.performanceIndicator ? (train.performanceIndicator === 'L' ? 'LATE' : '') : ''}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.loads}}
					</span>
                    <span class="train-value">
						{{train && train.loads ? train.loads : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.empties}}	
					</span>
                    <span class="train-value">
						{{train && train.empties ? train.empties : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
					{{trainLabel.tons}}
					</span>
                    <span class="train-value">
						{{train && train.tons ? train.tons : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.tofc}}
					</span>
                    <span class="train-value">
						{{train && train.tofc ? train.tofc : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.autos}}
					</span>
                    <span class="train-value">
						{{train && train.autos ? train.autos : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.length}}
					</span>
                    <span class="train-value">
						{{train && train.length ? train.length : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.previous}}	
					</span>
                    <span class="train-value">
						{{train && train.previousTerminal ? train.previousTerminal : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.routeNext}}
					</span>
                    <span class="train-value">
						{{train && train.nextTerminal ? train.nextTerminal : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.scheduled}}
					</span>
                    <span class="train-value" *ngIf='train && returnDash([train.scheduledText, train.scheduledDate, train.scheduledTime])'>
            -
					</span>
                    <span class="train-value" *ngIf='train && !returnDash([train.scheduledText, train.scheduledDate, train.scheduledTime])'>
            {{train.scheduledText}} {{train.scheduledDateTime}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.note}}
					</span>
                    <span class="train-value">
						{{train && train.trainnote ? train.trainnote : '-'}}
					</span>
                </li>
                <li>
                    <span class="train-label">
						{{trainLabel.powerPlan}}
					</span>
                    <span class="train-value no-padding" *ngIf='(train && train.powerPlans && train.powerPlans.length > 0)'>
						<ul>
							<li *ngFor='let powerPlan of train?.powerPlans'>
								{{powerPlan ? powerPlan : '-'}}
							</li>
						</ul>
					</span>
                    <span class="train-value" *ngIf='!(train && train.powerPlans && train.powerPlans.length > 0)'>
						-
					</span>
                </li>
            </ul>
        </div>
    </div>
</div>